module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/830c41fe6ccee48f10aada1895795874.png";